export default __webpack_public_path__ + "static/media/IBimagePelvicobliquity1.e8da2001.png";